<template>
  <div>
    <svg class="svg" viewBox="0 0 800 560">
      <image :xlink:href="src" x="0" y="0" height="100%" width="100%" />
      <rect
        :class="{
          spot: true,
          active: spot.active,
          hover: spot.hover,
        }"
        @click="setNewSpot(spot.bildposNummer, 'active')"
        @mouseenter="setNewSpot(spot.bildposNummer)"
        v-for="(spot, key) in hotspots"
        :key="key"
        :x="spot.x1Koordinate - 5"
        :y="spot.y1Koordinate - 5"
        opacity="0"
        :height="spot.y2Koordinate - spot.y1Koordinate + 10"
        :width="spot.x2Koordinate - spot.x1Koordinate + 10"
        :pos="spot.bildposNummer"
      />
    </svg>
  </div>
</template>

<script>
import hotspots from '../../mixins/hotspots';

export default {
  name: 'ProductImage',
  mixins: [hotspots],
  props: {
    src: {
      type: String,
      required: true,
    },
    alt: {
      type: String,
    },
  },
  methods: {
    setNewSpot(spot, type) {
      this.setSpotState(spot, type);
      if (type === 'active') {
        const activeProduct = window.document.querySelector(`.spot-${spot}`);
        if (activeProduct) {
          activeProduct.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.svg {
  width: 100%;
  height: 100%;
}

.spot {
  cursor: pointer;
}

.hover {
  stroke: var(--c-secondary);
  stroke-width: 4;
  opacity: 1;
  fill-opacity: 0;
}

.active {
  stroke: var(--_c-blue-primary);
  stroke-width: 4;
  opacity: 1;
  fill-opacity: 0;
}
</style>
